// utils/secureVideoUtils.js
// 🛡️ Secure Video Utilities - للتعامل مع الفيديوهات بشكل آمن

import { getServerUrl } from '../config/apiConfig';

const SERVER_BASE_URL = getServerUrl();

/**
 * الحصول على رابط تشغيل الفيديو الآمن من السيرفر
 * @param {string|number} lessonId - معرف الدرس
 * @returns {Promise<{url: string, videoSource: string}>} رابط الفيديو والنوع
 */
export const getSecureVideoUrl = async (lessonId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('يجب تسجيل الدخول أولاً');
    }

    const response = await fetch(`${SERVER_BASE_URL}/api/lessons/${lessonId}/play`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      if (response.status === 403) {
        throw new Error('لا تملك صلاحية مشاهدة هذا الدرس');
      } else if (response.status === 404) {
        throw new Error('الدرس غير موجود');
      } else {
        throw new Error('فشل في الحصول على رابط التشغيل');
      }
    }

    const data = await response.json();
    
    if (!data.success || !data.url) {
      throw new Error('لم يتم الحصول على رابط التشغيل');
    }

    const videoSource = data.videoSource || 'unknown';
    
    // التحقق من أمان الرابط (فقط للفيديوهات Bunny)
    if (videoSource === 'bunny') {
      if (!data.url.includes('token=')) {
        throw new Error('رابط الفيديو غير آمن - ناقص التوقيع');
      }
    }

    return {
      url: data.url,
      videoSource: videoSource
    };

  } catch (error) {
    throw error;
  }
};

/**
 * التحقق من أمان رابط الفيديو
 * @param {string} videoUrl - رابط الفيديو
 * @returns {boolean} هل الرابط آمن
 */
export const isSecureVideoUrl = (videoUrl) => {
  if (!videoUrl) return false;
  
  // يجب أن يحتوي على token
  if (!videoUrl.includes('token=')) {
    return false;
  }
  
  // يجب أن يكون من مصدر موثوق
  const trustedSources = [
    'iframe.mediadelivery.net',
    SERVER_BASE_URL.replace('https://', '').replace('http://', '')
  ];
  
  return trustedSources.some(source => videoUrl.includes(source));
};

/**
 * الحصول على معلومات الدرس مع رابط التشغيل الآمن
 * @param {string|number} lessonId - معرف الدرس
 * @returns {Promise<Object>} معلومات الدرس والرابط الآمن
 */
export const getSecureLessonInfo = async (lessonId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('يجب تسجيل الدخول أولاً');
    }

    const response = await fetch(`${SERVER_BASE_URL}/api/lessons/${lessonId}/play`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('فشل في الحصول على معلومات الدرس');
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error('لم يتم الحصول على معلومات الدرس');
    }

    return data;

  } catch (error) {
    throw error;
  }
};
